module.exports = __webpack_public_path__ + "img/006.cf2f317d.jpg";